<script setup lang="ts">
withDefaults(
    defineProps<{
        value: number;
        label: string;
        highlight?: boolean;
        customCss?: string;
        labelCss?: string;
    }>(),
    {
        highlight: false,
        customCss: '',
        labelCss: '',
    },
);

const { getFormattedPrice } = usePrice();
</script>

<template>
    <div
        class="mb-1 flex justify-between text-sm"
        :class="{
            '!text-lg font-extrabold': highlight,
            [customCss || '']: !!customCss,
        }"
    >
        <p :class="labelCss">
            {{ label }}
        </p>
        <span>{{ getFormattedPrice(value) }}</span>
    </div>
</template>
